export enum Panel {
  Alternating = "alternating",
  Solid = "solid"
}

export enum Valance {
  Canopy = "none",
  Standard = "standard",
  Whale = "whale",
  ClassicScallop = "scallop",
  ClassicScallopShort = "scallop-short",
  French = "french",
  Roman = "roman",
  WaveScallop = "wave-scallop",
  WaveScallopShort = "wave-scallop-short",
  VintageScallop = "vintage-scallop"
}

export enum ValanceDisplayName {
  Standard = "Standard",
  Whale = "Whale Tail",
  ClassicScallop = "Classic Scallop",
  ClassicScallopShort = "Classic Scallop (Short)",
  WaveScallop = "Wave Scallop",
  WaveScallopShort = "Wave Scallop (Short)",
  Roman = "Roman",
  French = "French",
  VintageScallop = "Vintage Scallop"
}

export function getValanceDisplayName(valance: Valance): string {
  const mapping: Record<Valance, string> = {
    [Valance.Canopy]: "None",
    [Valance.Standard]: ValanceDisplayName.Standard,
    [Valance.Whale]: ValanceDisplayName.Whale,
    [Valance.ClassicScallop]: ValanceDisplayName.ClassicScallop,
    [Valance.ClassicScallopShort]: ValanceDisplayName.ClassicScallopShort,
    [Valance.WaveScallop]: ValanceDisplayName.WaveScallop,
    [Valance.WaveScallopShort]: ValanceDisplayName.WaveScallopShort,
    [Valance.Roman]: ValanceDisplayName.Roman,
    [Valance.French]: ValanceDisplayName.French,
    [Valance.VintageScallop]: ValanceDisplayName.VintageScallop
  };
  return mapping[valance] || valance;
}

export enum Fringe {
  None = "none",
  Brush = '1" brush',
  Bullion3 = '3" bullion',
  Bullion5 = '5" bullion'
}

export enum FringeHandle {
  Brush = "F1",
  Bullion3 = "F3",
  Bullion5 = "F5"
}

export function getFringeDisplayName(fringe: Fringe): string {
  const mapping: Record<Fringe, string> = {
    [Fringe.None]: "None",
    [Fringe.Brush]: '1" Brush',
    [Fringe.Bullion3]: '3" Bullion',
    [Fringe.Bullion5]: '5" Bullion'
  };
  return mapping[fringe] || fringe;
}

export function getFringeImageName(fringe: Fringe): string | null {
  const mapping: Record<Fringe, string | null> = {
    [Fringe.None]: null,
    [Fringe.Brush]: "fringe/Fringe_spec_hero.svg",
    [Fringe.Bullion3]: "fringe/3-Bullion_spec_hero.svg",
    [Fringe.Bullion5]: "fringe/5-Bullion_spec_hero.svg"
  };
  return mapping[fringe] || null;
}

export enum Rib {
  Pockets = "pocket",
  Grommets = "grommet"
}

export enum BottomPole {
  Standard = "standard",
  Bar = "bar"
}

export enum Spigot {
  Standard = "standard",
  StainlessSteel = "stainless steel"
}

export function getSpigotDisplayName(spigot: Spigot): string {
  const mapping: Record<Spigot, string> = {
    [Spigot.Standard]: "Standard",
    [Spigot.StainlessSteel]: "Stainless Steel"
  };
  return mapping[spigot] || spigot;
}

export enum Finial {
  Ball = "ball",
  Vertex = "vertex"
}

export enum FinialFinishType {
  TPU = "tpu",
  CH = "chrome",
  SS = "ss"
}

export enum Preset {
  S1 = "S1",
  S1DV = "S1DV",
  D1 = "D1",
  D2 = "D2",
  D3 = "D3",
  D4 = "D4",
  D5 = "D5"
}

export enum StandardLayoutNames {
  Single = "Single Vent",
  Double = "Double Vent"
}

export enum PresetDesignerNames {
  None = "N/A",
  D1 = "Single Trim",
  D2 = "Double Trim",
  D3 = "Triple Trim"
}

export enum Stem {
  Stem8ST = "8ST",
  Stem18ST = "18ST",
  Stem18ST2 = "18ST2"
}
